import { render, staticRenderFns } from "./VesselInfoContentCard.vue?vue&type=template&id=379368bb&scoped=true&"
import script from "./VesselInfoContentCard.vue?vue&type=script&lang=ts&"
export * from "./VesselInfoContentCard.vue?vue&type=script&lang=ts&"
import style0 from "./VesselInfoContentCard.vue?vue&type=style&index=0&id=379368bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379368bb",
  null
  
)

export default component.exports